import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Link } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
// import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import SkipbarcodeConfirmationModal from "../../../components/Modal/CleanupConfirmation";

import ApproveConfirmationModal from "../../../components/Modal/ApproveConfirmation";
// import Loader from "../../../../components/Loader/Loader";

// import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";
import * as XLSX from "xlsx";

import moment from "moment";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import config from "../../../config/config";
import { toastError } from "../../../common/Toast";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import {
  ERROR_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../common/Constant";
import CleanupConfirmationModal from "../../../components/Modal/CleanupConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";
import { Noimage } from "../../../common/imagePath";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";

import { Box, MenuItem } from "@mui/material";
import { handleSaveColumnOrder } from "../../../common/common";
import CommonMatrialReactTableServerSideRender from "../../../components/Datatable/CommonMatrialReactTableServerSideRender";

// The below variable are for permission given to the Functionalities

const EcommUsers = () => {
  let selectData = [];
  let pathforpdf = "";
  let selectDatas = [];
  // let excelalldata;
  const token = localStorage.getItem("Token");
  const loginuserid = localStorage.getItem("ID");
  const [perPageSize, setperPageSize] = useState(25);
  const [data, setData] = useState([]);
  console.log(data, "datagory");
  const [sortingId, setSortingId] = useState(6);
  const [state, setState] = useState("");
  const [isactive, setIsActive] = useState(0);

  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);

  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  console.log(globalFilter, "globalFilter----->");

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };
  //BARCODE

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    console.log(columnFilters, "89889898");
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    console.log(columnFilters, "columnFilters------->");
    axios
      .get(
        `${
          config.customersBaseUrl
        }/customers/ecommpendingcustomer?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&loginId=${loginuserid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData, "1478");
        setData(res.data.ResponseData?.list);
        setRowCount(res.data.ResponseData?.list[0]?.TotalRecord);
        setIsActive(res.data.ResponseData[0]?.IsActive);
        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  // pdf make onclick

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };

  useEffect(() => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [columnFilters, globalFilter, pagination, sorting]);

  const handleApprove = (row) => {
    localStorage.setItem("userid", row.original.Id);
    setDeleteModalOpen(true);
  };

  const columns = useMemo(() => [
    {
      header: "Name",
      accessorKey: "Name",
      size: "170",
    },
    {
      header: "Username",
      accessorKey: "Username",
    },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
      size: "180",
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
    },
    {
      header: "E-Mail",
      accessorKey: "EmailId",
    },
    {
      header: "Phone Number",
      accessorKey: "Phonenumber",
      // size: "100",
    },
    {
      header: "Info Updated",
      accessorKey: "IsModified",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            // backgroundColor: '#E8F7F5',
            borderRadius: "0.3rem",
            color:
              row.original.IsModified == "Updated"
                ? "var(--success-main-color)"
                : "var(--error-main-color)",
            maxWidth: "9ch",
            p: "0.3rem",
            fontWeight: "bold",
          })}
        >
          {row.original.IsModified}
        </Box>
      ),
      // size: "100",
    },
    {
      header: "Email Verified",
      accessorKey: "IsVerifiedUser",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            // backgroundColor: '#E8F7F5',
            borderRadius: "0.3rem",
            color:
              row.original.IsVerifiedUser === "Verified"
                ? "var(--success-main-color)"
                : "var(--error-main-color)",
            maxWidth: "9ch",
            p: "0.3rem",
            fontWeight: "bold",
          })}
        >
          {row.original.IsVerifiedUser}
        </Box>
      ),
      // size: "100",
    },
    {
      header: "Status",
      accessorKey: "CustomerId",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            // backgroundColor: '#E8F7F5',
            borderRadius: "0.3rem",
            color:
              row.original.CustomerId == "Approved"
                ? "var(--success-main-color)"
                : "var(--error-main-color)",
            maxWidth: "9ch",
            p: "0.3rem",
            fontWeight: "bold",
          })}
        >
          {row.original.CustomerId}
        </Box>
      ),
      // size: "100",
    },
  ]);

  // const handleExcelExport = () => {
  //   setLoading(true);
  //   axios({
  //     url: `${config.customersBaseUrl}/customers/exportexcel`,
  //     method: "POST",
  //     data: {
  //       filtertext: searchtext,
  //       ordercolumn: sortingId,
  //       currentorder: sortingDirection,
  //     },
  //     headers: {
  //       Authorization: token,
  //     },
  //     responseType: "blob", // set response type to blob
  //   })
  //     .then((res) => {
  //       const url = window.URL.createObjectURL(new Blob([res.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "data.xlsx"); // set file name
  //       document.body.appendChild(link);
  //       link.click();
  //       toastSuccess(DATA_EXPORT);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       toastError(ERROR_MESSAGE);
  //       setLoading(false);
  //     });
  // };

  // function handleCheckboxChange(columnName) {
  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }

  // // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))

  const renderRowActionMenuItems = ({ row, closeMenu }) => [
    row.original.IsActive == 0 ||
    row.original.IsActive == null ||
    row.original.IsModified == 1 ? (
      // checkUserPermission(PERMISSION_DELETE) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"

        // title="Approve"
        // data-bs-target="#ApproveConfirmationModal"
        onClick={() => handleApprove(row)}
      >
        Approve
      </MenuItem>
    ) : null,
    // ) : (
    //   ""
    // ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                  (checkUserPermission("mark-inactive") ? (
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleDeletePopup(
                          "",
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      // startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Mark InActive
                    </Button>
                  ) : (
                    " "
                  ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col-md-12"> */}

              {/* <div className="col"> */}
              {/* <h3 className="page-title">Ecomm Users</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Ecomm Users List</li>
              </ul>
              {/* </div> */}
            </div>

            <div className="pull-right ms-2">
              {/* <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm  pull-right"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  /> */}
            </div>

            {/* <div>
              
              <div className="btn-group-sm pull-right ms-2 dropdown">
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button>
                <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } // check all checkboxes which are not include in hiddenColumns
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div>
              <div className="btn-group-sm pull-right ms-2">
                <button type="button" className="btn btn-outline-dark d-none">
                  More
                </button>
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle me-1"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  More &nbsp;
                  
                </button>
                <div className="dropdown-menu">
                  <li>
                    {checkUserPermission(PERMISSION_CUSTOMER_INTAKE_FORM) ? (
                      <Link class="dropdown-item" to="/customer-intake-form">
                        Customer Intake Form
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_IMPORT) ? (
                      <Link class="dropdown-item" to="/import-excel-customers">
                        Excel Import
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                      <Link class="dropdown-item" onClick={handleExcelExport}>
                        Excel Export
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_MANAGE_DELETED_CUSTOMERS
                    ) ? (
                      <Link class="dropdown-item" to="/deleted-customers">
                        Manage Deleted Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(PERMISSION_CLEANUP_OLD_CUSTOMERS) ? (
                      <Link
                        to="#"
                        title="Cleanup old Customers"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup old Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  <li>
                    {checkUserPermission(
                      PERMISSION_CUSTOM_FIELD_CONFIGURATION
                    ) ? (
                      <Link
                        to="/custom-field-configuration"
                        title="Custom Field Configuration"
                        className="dropdown-item"
                      >
                        Customer Custom Fields
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                </div>
              </div>

              {checkUserPermission(PERMISSION_ADD) ? (
                <Link
                  to="/manage-customers"
                 
                  className="btn btn-primary btn-sm pull-right" style={{width:"max-content"}}
                >
                  <i className="fa fa-plus me-2 lg"></i>
                  New Customer
                </Link>
              ) : (
                ""
              )}
            </div> */}
          </div>

          {/* <Link
            to="/customer-intake-form"
            className="btn btn-primary pull-right ms-2"
          >
            <i className="fa fa-download me-2 lg"></i>
            Customer Intake Form
          </Link>
          <Link
            to="/import-excel-customers"
            className="btn btn-primary pull-right ms-2"
          >
            <i className="fa fa-upload me-2 lg"></i>
            Excel Import
          </Link>
          <Link
            className="btn btn-primary pull-right ms-2"
            onClick={handleExcelExport}
          >
            <i className="fa fa-download me-2 lg"></i>
            Excel Export
          </Link>
          <Link
            to="/deleted-customers"
            className="btn btn-primary pull-right ms-2"
          >
            <i className="fa fa-trash me-2 lg"></i>
            Manage Deleted Customers
          </Link>
          <Link
            to="#"
            title="Cleanup old Customers"
            className="btn btn-primary pull-right mb-2 ms-2"
            data-bs-toggle="modal"
            data-bs-target="#CleanupConfirmationModal"
          >
            <i
              className="fa fa-trash me-2 lg"
              data-bs-toggle="tooltip"
              title="Cleanup old Customers"
            ></i>
            Cleanup old Customers
          </Link>
          <Link
            to="/custom-field-configuration"
            title="Custom Field Configuration"
            className="btn btn-primary pull-right ms-2"
            // data-bs-toggle="modal"
            // data-bs-target="#CustomFieldConfiguration"
          >
            <i
              className="fa fa-trash me-2 lg"
              data-bs-toggle="tooltip"
              title="Custom Field Configuration"
            ></i>
            Custom Field Configuration
          </Link>
          <br />
          <br /> */}
          {/* <div className="row mt-2">
            <div className="col-lg-12 col-md-6 col-sm-12">
              <div className="d-flex flex-wrap">
                <div className="p-3 col-lg-2 col-md-6 col-sm-12 mt-2 ">
                  <input
                    type="search"
                    placeholder="Search..."
                    className="search-btn form-control form-control-sm w-100 pull-right"
                    onChange={ChangeFilterText}
                    value={searchtext}
                  />
                </div>
                <div className="p-2 mt-3 col-md-3">
                  <Select
                    defaultValue={quickBookOptions}
                    onChange={(event) => {
                      handleQuickBookChange("ExcelExport", event);
                    }}
                    options={options}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    isClearable={true}
                    // hideSelectedOptions={true}
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    id="ExcelExport"
                    name="ExcelExport"
                    className="custom-search-select"
                  />
                </div>
                {quickBookOptions?.value == 2 && (
                  <>
                    <div className="p-3 col-lg-2 col-md-6 col-sm-12">
                      Custom Start Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="StartDate"
                        name="StartDate"
                        onChange={(event) =>
                          handleChangeCustomStartingDate(event)
                        }
                      />
                    </div>
                    <div className="p-3 col-lg-2 col-md-6 col-sm-12">
                      Custom End Date:
                      <input
                        type="date"
                        className="form-control form-control-sm"
                        id="EndDate"
                        name="EndDate"
                        onChange={(event) =>
                          handleChangeCustomEndingDate(event)
                        }
                      />
                    </div>
                    <div className="p-3 col-lg-1 col-md-6 col-sm-12 mt-3">
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => handleSearchAccordingToDate()}
                      >
                        Search
                      </button>
                    </div>
                  </>
                )}

                <div className="p-2 col-lg-3 col-md-6 col-sm-12 mt-3">
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => handleQuickBookDownload()}
                  >
                    Export to excel for quickbook
                  </button>
                </div>
                {quickBookOptions?.value !== 2 && (
                  <>
                    <div className="p-3 col-lg-4 col-md-3 col-sm-12"></div>
                  </>
                )}

              </div>
            </div>
          </div> */}

          {/* Customer list */}
          {/* <div className="card"> */}
          <div className="card-body" style={{ padding: "10px 20px 10px 20px" }}>
            <div className="email-header">
              <div className="row ">
                <div className="col-lg-200 top-action-left col-sm-20">
                  <div className="">
                    {/* <DataTable
                      title="Ecomm Users List"
                      columns={columns}
                      data={data}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={(e) => {
                        handlePerRowsChange(1, e);
                      }}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      striped
                      responsive
                      paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                      // fixedHeader
                      // fixedHeaderScrollHeight="70vh"
                      persistTableHead
                      sortServer
                      onSort={handleSort}
                    //   selectableRows

                      // onSelectedRowsChange={e => { handleSelectedRowsChange(e); }}
                   
                      //   contextActions={contextActions}
                      // onSelectedRowsChange={handleRowSelected}
                      // clearSelectedRows={toggleCleared}
                      dense
                    /> */}

                    <div className="row d-flex">
                      {checkUserPermission("export-button") ? (
                        
                          <button
                            // className="btn btn-added pull-right"
                            className="btn btn-sm btn-outline-dark btn-sm mb-3 mr-3"
                            style={{ width: "max-content" }}
                            onClick={() => onBtExport([], "AllData")}
                          >
                            <i
                              className="fa fa-download mr-2"
                              style={{ color: "#111930" }}
                            ></i>
                            Export Visible Column
                            {/* <i class="fa-thin fa-download"></i> */}
                          </button>
                    
                      ) : (
                        ""
                      )}

<div
                  className="cursor-pointer mt-1 col-md-2"
                  onClick={() =>
                    handleSaveColumnOrder(
                      loginuserid,
                      "EcomUsers",
                      columnOrder,
                      token,
                      columnVisibility
                    )
                  }
                  title="Lock Your Sequence"
                  // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                  // onMouseLeave={() => setIcon(ColumnOrderIcon)}
                >
                  <i class="fa fa-lock columnsLock fs-4"></i>
                </div>
                    </div>

                    <CommonMatrialReactTableServerSideRender
                      MainHeading="Sonar POS"
                      ReportHeading="EcommUsers List"
                      columns={columns}
                      data={data}
                      // startdate={startdate}
                      // enddate={enddate}
                      columnGrouping={[]}
                      columnsVisibility={{}}
                      enableRowActions={
                        checkUserPermission("/manage-employee/:id") ||
                        checkUserPermission("/deleted-employees") ||
                        checkUserPermission("change-password")
                      }
                      enableRowSelection={true}
                      renderRowActionMenuItems={renderRowActionMenuItems}
                      renderTopToolbarCustomActions={
                        renderTopToolbarCustomActions
                      }
                      density="comfortable"
                      showGlobalFilter={true}
                      showColumnFilters={false}
                      expanded={true}
                      pagination={{ pageIndex: 0, pageSize: 25 }}
                      rowCount={rowCount}
                      setColumnFilters={setColumnFilters} // for termp comment filteron column
                      setGlobalFilter={setGlobalFilter}
                      setPagination={setPagination}
                      setSorting={setSorting}
                      setColumnOrder={setColumnOrder}
                      setColumnVisibility={setColumnVisibility} //setColumnVisibility
                      state={{
                        columnFilters, // for termp comment filteron column
                        // globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                        columnOrder,
                        columnVisibility,
                      }}
                    />
                    {/* <MaterialReactTable
                      columns={columns}
                      data={data}
                      // positionPagination='top'
                      enableColumnResizing
                      enableGrouping
                      enableStickyHeader
                      enableStickyFooter
                      // enableRowSelection
                      enableColumnOrdering
                      enableRowActions
                      positionGlobalFilter="left"
                      // enableEditing

                      renderRowActionMenuItems={({ row }) => [
                        row.original.IsActive == 0 ||
                        row.original.IsActive == null ||
                        row.original.IsModified == 1 ? (
                          // checkUserPermission(PERMISSION_DELETE) ? (
                          <MenuItem
                            className="confirm-text"
                            to="#"
                            // key="delete"

                            // title="Approve"
                            // data-bs-target="#ApproveConfirmationModal"
                            onClick={() => handleApprove(row)}
                          >
                            Approve
                          </MenuItem>
                        ) : null,
                        // ) : (
                        //   ""
                        // ),
                      ]}
                      rowVirtualizerOptions={{
                        overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
                        estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
                      }}
                      muiTableBodyProps={{
                        sx: () => ({
                          "& tr:nth-of-type(even)": {
                            backgroundColor:
                              "var(--datatable-row-background-color)",
                            //'rgb(237 237 233 / 63%)'
                          },
                          "& td": {
                            borderRight:
                              "1px solid var(--datatable-row-background-hover-color)",
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },

                          "& tr": {
                            lineHeight: "16px",
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "var(--primary-color-800)",
                            fontFamily: "Inter",
                          },
                        }),
                      }}
                      muiTableContainerProps={{
                        sx: { maxHeight: "fit-content" },
                      }}
                      initialState={{
                        density: "compact",
                        showGlobalFilter: true,
                        expanded: true, //expand all groups by default
                        // grouping: [""], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 25 },
                        // sorting: { id: "Name", desc: false }, //sort by state by default
                      }}
                      muiPaginationProps={{
                        rowsPerPageOptions: [10, 25, 50, 100, 300],
                      }}
                      manualPagination
                      manualSorting
                      muiToolbarAlertBannerProps={
                        isError
                          ? {
                              color: "error",
                              children: "Error loading data",
                            }
                          : undefined
                      }
                      // onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
                      muiTableHeadCellProps={{
                        sx: (theme) => ({
                          background: "var(--datatable-row-background-color)", //'#e9e9e9',
                          borderRight:
                            "1px solid var(--datatable-row-background-hover-color)",
                          lineHeight: "16px",
                          fontWeight: "500",
                          fontSize: "14px",
                          color: "var(--primary-color-800)",
                          fontFamily: "Inter",
                        }),
                      }}
                      onGlobalFilterChange={setGlobalFilter}
                      onPaginationChange={setPagination}
                      onColumnFiltersChange={setColumnFilters}
                      onSortingChange={setSorting}
                      rowCount={rowCount}
                      // enableColumnVirtualization={false}
                      // enableColumnVirtualization
                      state={{
                        // columnFilters, // for termp comment filteron column
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                      }}
                    />  */}
                    {/* <Table columns={columns} dataSource={data} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* </div> */}

      <ApproveConfirmationModal
        upsertApiUrl={`${config.customersBaseUrl}/customers/ecommuserupsert`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
      />
    </>
  );
};

export default EcommUsers;
